import React from "react";
import "./featureNewBadge.scss";

export interface FeatureNewBadgeProps {
  label?: string;
  className?: string;
}

const FeatureNewBadge: React.FC<FeatureNewBadgeProps> = ({
  label = "NEW",
  className,
}) => (
  <span className={`xgs-feature-new-badge${className ? ` ${className}` : ""}`}>
    {label}
  </span>
);

export default FeatureNewBadge;
